import axios from 'axios';

export const subscribeToNewsletter = async (email) => {
    const apiUrl = `${process.env.REACT_APP_SERVER_URL}/newsletter/subscribe`;
  try {
    const response = await axios.post(apiUrl, { email });
    return response.data;
  } catch (error) {
    console.error('Error subscribing to newsletter:', error);
    throw error;
  }
};
